<!--
 * @Description: 设备外包
 * @Autor: wangwangwang
 * @Date: 2021-01-28 20:05:18
 * @LastEditors: hexy 913752270@qq.com
 * @LastEditTime: 2026-06-23 14:24:47
-->
<template>
  <div class="table equipment">
    <div class="card">
      <div class="card_nav">
        <div>
          <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'TIANJIA') !== -1" size="small"
            class="bottom_all" style="margin-left: 0" @click="addFromDate('添加'), reset()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
          <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'TIANJIA') !== -1" size="small" class="bottom_all" style="margin-left: 12px" :disabled="yiFenPeiRadio == ''" @click="contractQueryDetailByIdFun(yiFenPeiRadio.id,true), (addDialogTitle = '修改'), (modifyType = false)">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            复用
          </el-button>
          <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'RIYONG') !== -1" size="small"
            class="bottom_three" @click="UpdateOrDelete('update_enable', 1)">
            <i class="icon iconfont iconicon_button_startuse" style="font-size: 12px"></i>
            启用
          </el-button>
          <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'JINYONG') !== -1" size="small"
            class="bottom_four" @click="UpdateOrDelete('update_enable', 0)">
            <i class="icon iconfont iconicon_button_disable1" style="font-size: 12px"></i>
            禁用
          </el-button>
          <el-button v-if="ButtonList.some(res => res.buttonValue == 'TIAOJIA')" size="small" class="botton_five"
            :disabled="yiFenPeiRadio == ''" @click="riseInPriceQueryOneByidFun(yiFenPeiRadio)">调价</el-button>
          <el-button v-if="ButtonList.some(res => res.buttonValue == 'KAIHUXINXI')" size="small" class="botton_five"
            :disabled="yiFenPeiRadio == ''" @click="queryListsByPidFun(yiFenPeiRadio)">开户信息</el-button>
          <el-button v-if="ButtonList.some(res => res.buttonValue == 'FENPEIZHANGHAO')" size="small" class="botton_five"
            :disabled="yiFenPeiRadio == ''" @click="open(yiFenPeiRadio, 'dialog1')">分配账号</el-button>
          <el-button size="small" class="botton_five" :disabled="yiFenPeiRadio == ''" @click="allsumHand">总结算</el-button>
        </div>
        <div>
          <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
            <el-link :underline="false">
              <span class="el-icon--left">
                <i class="iconfont iconicon_button_filtrate"></i>
              </span>
              筛选
            </el-link>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item, index) in table" :key="index">
                <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-link v-if="ButtonList.findIndex(res => res.buttonValue == 'DAOCHU') !== -1" :underline="false"
            @click="load()">
            <span class="el-icon--left">
              <i class="iconfont iconicon_button_export1"></i>
            </span>
            导出
          </el-link>
        </div>
      </div>
      <div v-loading="tableLoading" class="card_info">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
            <template slot-scope="scope">
              <el-radio v-model="yiFenPeiRadio" :label="scope.row">{{ "" }}</el-radio>
            </template>
          </el-table-column>
          <template v-for="(item, index2) in table">
            <el-table-column v-if="item.label == '操作'" :key="index2" fixed="right" :label="item.label" align="center"
              :width="item.width">
              <template slot-scope="scope">
                <el-dropdown :hide-on-click="false" trigger="click">
                  <el-button size="mini" class="bottom_one">更多</el-button>
                  <el-dropdown-menu slot="dropdown" style="text-align: left">
                    <el-dropdown-item v-if="ButtonList.some(res => res.buttonValue == 'XIUGAI')">
                      <el-button style="margin: 5px 0" class="bottom_one" size="mini"
                        @click="contractQueryDetailByIdFun(scope.row.id), (addDialogTitle = '修改'), (modifyType = false)">
                        修改 </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-button size="mini" style="margin: 5px 0" class="bottom_one"
                        @click="$refs.ModifyTheRecord.contractQueryPageContractLogFun(scope.row.id)">更改记录</el-button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
            <el-table-column v-else-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width">
              <template slot-scope="scope">
                <div v-if="item.label == '状态'">
                  <span v-if="scope.row.enable == 0" style="color: #969799">禁用</span>
                  <span v-else-if="scope.row.enable == 1" style="color: #00a754">启用</span>
                </div>
                <el-link v-else-if="item.label == '合同ID'" class="table_link" :underline="false"
                  @click="contractQueryDetailByIdFun(scope.row.id), (addDialogTitle = '查看')">{{ scope.row.code
                  }}</el-link>
                <div v-else-if="item.label == '站点名称'">
                  <span>{{ scope.row.stations | stationsFun }}</span>
                </div>
                <el-link v-else-if="item.label == '协作单位'" class="table_link" :underline="false"
                  @click="cooperativeUnitFun(scope.row)">协作单位</el-link>
                <div v-else-if="item.label == '合同签订情况'">
                  <span v-if="scope.row.concludeAndSignStatus == 1">已签订</span>
                  <span v-else>未签订</span>
                </div>
                <div v-else-if="item.label == '华西云采注册情况'">
                  <span v-if="scope.row.loginStatus == 1">已注册</span>
                  <span v-else>未注册</span>
                </div>
                <div v-else-if="item.label == '合同有效期'">{{ scope.row.startDay + " - " + scope.row.endDay }}</div>
                <span v-else-if="item.label == '合同有效期'" style="color: #969799">{{ scope.row.contractBeginTime }} -- {{
                  scope.row.contractEndTime }}</span>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total"
            @size-change="sizeChange" @current-change="gettableData(), (yiFenPeiRadio = '')"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </div>
    <!-- 添加·合同 -->
    <el-dialog v-dialogDrag :visible.sync="addDialog" width="1015px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div class="dialoginfo FZYform scroll" style="height: calc(85vh - 230px); padding-right: 5px; overflow: auto">
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="formDate" label-width="110px">
          <div class="form-title">基本信息</div>
          <el-form-item prop="facilityType">
            <span slot="label">合同类型</span>
            <el-select v-model="formDate.facilityType" placeholder="请选择" :disabled="modifyType" style="width:340px ;"
              @change="facilityTypeFun()">
              <el-option label="泵车" :value="1"></el-option>
              <el-option label="装载机" :value="2"></el-option>
              <el-option label="耐磨件" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="firstPartyId">
            <span slot="label">权限公司</span>
            <el-select ref="selection1" v-model="formDate.firstPartyId" placeholder="请选择" style="width:340px ;"
              :disabled="modifyType" @change="
                companylistChangeFun(true, formDate.firstPartyId),
                $nextTick(() => {
                  formDate.firstParty = $refs.selection1.selectedLabel;
                })
                ">
              <el-option v-for="(item, index) in companylist" :key="index" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="contractSigningSubjectId">
            <span slot="label">合同签订主体</span>
            <el-select ref="selection1" v-model="formDate.contractSigningSubjectId" placeholder="请选择"
              style="width:340px ;" :disabled="modifyType" @change="
                $nextTick(() => {
                  formDate.contractSigningSubject = $refs.selection1.selectedLabel;
                })
                ">
              <el-option v-for="(item, index) in roadWorkList" :key="index" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="stationsList" :rules="[{ required: true, message: '请选择站点', trigger: 'change' }]"
            style="width:340px ;">
            <span slot="label">站点名称</span>
            <el-select v-model="formDate.stationsList" placeholder="请选择" multiple :disabled="modifyType">
              <el-option v-for="(item, index) in sitelist" :key="index" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="supplierId">
            <span slot="label">主合同单位</span>
            <el-select v-model="formDate.supplierId" filterable placeholder="请选择" style="width: 340px"
              :disabled="modifyType" @change="changemainCompanyId(formDate.supplierId)">
              <el-option v-for="(item, index) in supplierList" :key="index" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">供应商类别</span>
            <div style="width: 340px">{{ formDate.supplierType }}</div>
          </el-form-item>
          <el-form-item prop="contractNumber">
            <span slot="label">合同编号</span>
            <el-input v-model="formDate.contractNumber" placeholder="请输入" clearable :disabled="modifyType"
              style="width:340px ;" @blur="queryContractNumberFun()"></el-input>
          </el-form-item>
          <el-form-item prop="callForBidsNumber">
            <span slot="label">招标编号</span>
            <el-input v-model="formDate.callForBidsNumber" placeholder="请输入" clearable :disabled="modifyType"
              style="width:340px ;"></el-input>
          </el-form-item>
          <el-form-item prop="concludeAndSignStatus">
            <span slot="label">合同签订情况</span>
            <el-select v-model="formDate.concludeAndSignStatus" placeholder="请选择" :disabled="modifyType"
              style="width:340px ;">
              <el-option label="已签订" :value="1"></el-option>
              <el-option label="未签订" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="loginStatus" label-width="140px">
            <span slot="label">华西云采注册情况</span>
            <el-select v-model="formDate.loginStatus" class="hyyc" placeholder="请选择" :disabled="modifyType"
              style="width:310px ;">
              <el-option label="已注册" :value="1"></el-option>
              <el-option label="未注册" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="linkman">
            <span slot="label">联系人</span>
            <el-input v-model="formDate.linkman" placeholder="请输入" clearable :disabled="modifyType"
              style="width:340px ;"></el-input>
          </el-form-item>
          <el-form-item prop="phone">
            <span slot="label">联系电话</span>
            <el-input v-model="formDate.phone" placeholder="请输入" clearable :disabled="modifyType"
              style="width:340px ;"></el-input>
          </el-form-item>
          <el-form-item prop="startDayendDay">
            <span slot="label">合同有效期</span>
            <el-date-picker v-model="formDate.startDayendDay" style="width: 340px" type="datetimerange" unlink-panels
              value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"
              :disabled="modifyType"></el-date-picker>
          </el-form-item>
          <el-form-item prop="taxRate">
            <span slot="label">税率</span>
            <el-select v-model="formDate.taxRate" placeholder="请选择" style="width: 340px" :disabled="modifyType">
              <el-option v-for="(item, index) in taxRateList" :key="index" :label="item.itemName"
                :value="item.itemValue"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item prop="dataType">
            <span slot="label">泵送队标识</span>
            <el-select v-model="formDate.dataType" placeholder="请选择" :disabled="modifyType">
              <el-option label="内部" :value="1"></el-option>
              <el-option label="外部" :value="2"></el-option>
            </el-select>
          </el-form-item> -->
          <div class="form-title">单价相关</div>
          <el-form-item v-if="formDate.facilityType == 1">
            <span slot="label">是否含泵管</span>
            <el-radio v-model="formDate.isPumpLine" :disabled="modifyType" :label="1">是</el-radio>
            <el-radio v-model="formDate.isPumpLine" :disabled="modifyType" :label="0">否</el-radio>
          </el-form-item>
          <el-form-item v-if="formDate.facilityType == 1">
            <span slot="label">是否车泵</span>
            <el-radio v-model="formDate.isPunpCar" :disabled="modifyType" :label="1">是</el-radio>
            <el-radio v-model="formDate.isPunpCar" :disabled="modifyType" :label="0">否</el-radio>
          </el-form-item>
          <div>
            <div class="form-title">设备价格</div>
            <div style="padding-bottom: 10px">
              <el-button size="mini" class="bottom_all" style="margin-left: 0" :disabled="modifyType" @click="addItem()">
                <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                添加
              </el-button>
            </div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
              style="width: 100%" :data="cplistArr" tooltip-effect="dark" class="FZYselectList">
              <el-table-column label="设备" align="center">
                <template slot-scope="scope">
                  <el-select v-if="formDate.facilityType == 1" v-model="scope.row.deviceId" size="mini" placeholder="选择"
                    :disabled="modifyType" style="width: 100% !important"
                    @change="contractId_contractNoFun(scope.row, scope.$index)">
                    <el-option v-for="item in pumpTypeArr" :key="item.id" :label="item.itemName"
                      :value="item.id"></el-option>
                  </el-select>
                  <el-input v-else v-model="scope.row.deviceName" size="mini" style="width: 100%" placeholder="输入设备"
                    :disabled="modifyType" />
                </template>
              </el-table-column>
              <el-table-column :label="columnList" align="center">
                <template slot-scope="scope">
                  <el-link v-if="formDate.facilityType == 1" class="table_link" :underline="false"
                    @click="basePriceListFun(scope.row.list, scope.$index)">设置</el-link>
                  <el-input v-else v-model="scope.row.basePrice" size="mini" style="width: 100%" placeholder="输入价格"
                    :disabled="modifyType" />
                </template>
              </el-table-column>
              <el-table-column label="考核价" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.assessmentPrice" size="mini" style="width: 100%" :disabled="modifyType"
                    onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                    @input="scope.row.assessmentPrice = $regExp.checkNum(scope.row.assessmentPrice)"
                    @blur="scope.row.assessmentPrice = $regExp.blurCheckNum(scope.row.assessmentPrice)" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="left" prop="specification">
                <template slot-scope="scope">
                  <el-button size="mini" class="bottom_two" :disabled="modifyType" @click="deleteItem(scope.$index)">
                    <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-form-item prop="oilPrice" style="margin-top: 10px"
            :rules="[{ required: formDate.facilityType == 1, message: '请输入柴油基准价', trigger: 'change' }]">
            <span slot="label">柴油基准价</span>
            <el-input v-model="formDate.oilPrice" placeholder="请输入" clearable :disabled="modifyType" style="width:340px ;"
              onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))" type="number"></el-input>
            <span style="margin-left: 10px">元/升</span>
          </el-form-item>
          <div v-if="formDate.isPumpLine == 1 && formDate.facilityType == 1" class="form-title">泵管价格</div>
          <div v-if="formDate.isPumpLine == 1 && formDate.facilityType == 1">
            <div style="padding-bottom: 10px">
              <el-button size="mini" class="bottom_all" style="margin-left: 0" :disabled="modifyType"
                @click="addItemPumpList()">
                <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                添加
              </el-button>
            </div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
              style="width: 100%" :data="pumpListArr" tooltip-effect="dark" class="FZYselectList">
              <el-table-column label="泵管类型" align="center" width="250">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.pumpTypeId" size="mini" placeholder="选择" :disabled="modifyType"
                    style="width: 100% !important" @change="pumpTypeId_pumpTypeFun(scope.row, scope.$index)">
                    <el-option v-for="item in pumpTubeArr" :key="item.id" :label="item.itemName"
                      :value="item.id"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="基础单价（元/方）" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.price" size="mini" style="width: 100%" placeholder="输入价格"
                    :disabled="modifyType" onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                    @input="scope.row.price = $regExp.checkNum(scope.row.price)"
                    @blur="scope.row.price = $regExp.blurCheckNum(scope.row.price)" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="left" prop="specification">
                <template slot-scope="scope">
                  <el-button size="mini" class="bottom_two" :disabled="modifyType"
                    @click="deleteItemPumpList(scope.$index)">
                    <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-form-item style="margin-top: 15px">
            <span slot="label">备注</span>
            <el-input v-model="formDate.cargoRemark" style="width: 580px" type="textarea" placeholder="请输入" clearable
              :rows="5" resize="none" :disabled="modifyType"></el-input>
          </el-form-item>
          <div class="form-title">结算规则</div>
          <el-form-item prop="clearingFormId">
            <span slot="label">结算周期</span>
            <!-- <el-select v-model="formDate.clearingFormId" placeholder="请选择" :disabled="modifyType">
              <el-option v-for="(item, index) in clearingFromIdList" :key="index" :label="item.name"
                :value="item.id"></el-option>
            </el-select> -->
            <el-select v-model="formDate.clearingFormId" placeholder="请选择"
              style="width: 100px !important; margin: 0 10px 0 0 " :disabled="modifyType">
              <el-option label="每月" value="1"></el-option>
              <el-option label="每3月" value="2"></el-option>
              <el-option label="每6月" value="3"></el-option>
              <el-option label="每12月" value="4"></el-option>
            </el-select>
            <span>结算一次，结算日为</span>
            <el-input-number v-model="formDate.stationDay" style="width: 50px !important; margin: 0 10px" :max="31"
              :disabled="modifyType" :controls="false"></el-input-number>
            <span>号</span>
          </el-form-item>
          <el-form-item prop="paymentMethod" :rules="[{ required: true, message: '请选择付款方式', trigger: 'change' }]">
            <span slot="label">付款方式</span>
            <el-select v-model="formDate.paymentMethod" placeholder="请选择" :disabled="modifyType" style="width:340px ;">
              <el-option label="账龄" :value="1"></el-option>
              <!-- <el-option label="比例" :value="2"></el-option> -->
            </el-select>
          </el-form-item>
          <!-- <el-form-item v-show="formDate.paymentMethod == 1" prop="aging" :rules="[{ required: formDate.paymentMethod * 1 === 1, message: '请选择账龄', trigger: 'change' }]">
            <span slot="label">账龄</span>
            <el-select v-model="formDate.aging" placeholder="请选择" :disabled="modifyType">
              <el-option label="1月" :value="1"></el-option>
              <el-option label="2月" :value="2"></el-option>
              <el-option label="3月" :value="3"></el-option>
              <el-option label="4月" :value="4"></el-option>
              <el-option label="5月" :value="5"></el-option>
              <el-option label="6月" :value="6"></el-option>
              <el-option label="7月" :value="7"></el-option>
              <el-option label="8月" :value="8"></el-option>
              <el-option label="9月" :value="9"></el-option>
              <el-option label="10月" :value="10"></el-option>
              <el-option label="11月" :value="11"></el-option>
              <el-option label="12月" :value="12"></el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item v-show="formDate.paymentMethod == 2" prop="paymentRatio" :rules="[{ required: formDate.paymentMethod * 1 === 2, message: '请输入支付比例', trigger: 'change' }]">
            <span slot="label">支付比例(%)</span>
            <el-input-number v-model="formDate.paymentRatio" :precision="2" style="width: 130px" :max="100" :disabled="modifyType" :controls="false"></el-input-number>
          </el-form-item> -->

          <!-- 新增字段修改  进度支付时段（账龄）、支付比例、尾款支付、尾款支付时段  -->
          <el-form-item prop="transitionPeriod" class="zq" label-width="180px">
            <span slot="label">进度支付时段（账龄）</span>
            <el-input-number v-model="formDate.transitionPeriod" style="width: 50px !important;margin-right: 10px"
              :disabled="modifyType" :controls="false"></el-input-number>
            <el-select v-model="formDate.periodUnit" placeholder="请选择" :disabled="modifyType">
              <el-option label="月" :value="1"></el-option>
              <el-option label="季度" :value="2"></el-option>
              <el-option label="年" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="payRatio" class="zq">
            <span slot="label">支付比例</span>
            <el-input-number v-model="formDate.payRatio" style="width: 50px !important;margin-right: 10px"
              :disabled="modifyType" :controls="false"></el-input-number>
            <span>%</span>
          </el-form-item>
          <el-form-item prop="balancePayment" class="zq">
            <span slot="label">尾款支付</span>
            <el-select v-model="formDate.balancePayment" placeholder="请选择" :disabled="modifyType">
              <el-option label="总结算后" :value="1"></el-option>
              <el-option label="合同有效期内" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="balancePaymentPeriod" class="zq" label-width="180px">
            <span slot="label">尾款支付时段<span v-if="formDate.balancePayment == 2">（账龄）</span> </span>
            <el-input-number v-model="formDate.balancePaymentPeriod" style="width: 50px !important;margin-right: 10px"
              :disabled="modifyType" :controls="false"></el-input-number>
            <el-select v-model="formDate.balanceUnit" placeholder="请选择" :disabled="modifyType">
              <el-option label="月" :value="1"></el-option>
              <el-option label="季度" :value="2"></el-option>
              <el-option label="年" :value="3"></el-option>
            </el-select>
          </el-form-item>


          <el-form-item>
            <span slot="label">结算说明</span>
            <el-input v-model="formDate.explains" style="width: 800px" type="textarea" placeholder="请输入" clearable
              :rows="2" resize="none" :disabled="modifyType" maxlength="200" show-word-limit></el-input>
          </el-form-item>
          <div class="form-title">增值服务</div>
          <el-form-item prop="processModel">
            <span slot="label">流程模式</span>
            <el-select v-model="formDate.processModel" placeholder="请选择" :disabled="modifyType" style="width:340px ;"
              @change="processModelFun()">
              <el-option label="传统工艺流程模式" value="1"></el-option>
              <el-option label="电子工艺流程模式" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label"></span>
            <el-button size="mini" class="bottom_all" style="margin-left: 0"
              @click="stationsControlPointFun()">管控业务点</el-button>
          </el-form-item>
          <div class="form-title">附件</div>
          <FileComponent fileCode="equipmentFile" :disabled="modifyType" :files="files" @deleteFile="deleteFile"
            @uplodeSuccess="uplodeSuccess" />
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="addDialog = false">关 闭</el-button>
        <el-button v-show="!modifyType" class="bottom_all" style="margin-left: 24px" :disabled="modifyType"
          @click="pagessubmitFromDate()">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 价格区间弹窗 -->
    <el-dialog v-dialogDrag :visible.sync="basePriceListType" width="800px">
      <span slot="title" class="dialog-title">设置泵送高度</span>
      <div class="dialoginfo FZY1-3">
        <!-- <el-button  class="bottom_text" :disabled="modifyType" @click="setFixedValue()">固定值</el-button> -->
        <el-tabs v-model="rangeFixedType" type="border-card" @tab-click="setFixedValue">
          <el-tab-pane label="区间" name="区间">
            <div v-for="(v3, k3) in carTwosArr" :key="k3">
              <div v-if="k3 == 0" class="liBox1">
                <div>
                  <span>小于等于</span>
                  <el-input-number v-model="v3.distance" style="width:50%" size="mini" :controls="false" :precision="2"
                    :disabled="modifyType" @blur="inpuSizeCheck(v3.distance, k3, carTwosArr)"></el-input-number>
                </div>
                <div>
                  <span>米</span>
                  <b>：</b>
                  <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0"
                    :disabled="modifyType"></el-input-number>
                  <span>元/方</span>
                </div>
              </div>
              <div v-if="k3 > 0 && k3 != carTwosArr.length - 1" class="liBox3">
                <div>
                  <div>
                    <el-input-number v-model="carTwosArr[k3 - 1].distance" size="mini" :controls="false" :precision="2"
                      disabled></el-input-number>
                    <span>至</span>
                    <el-input-number v-model="v3.distance" size="mini" :controls="false" :precision="2"
                      :disabled="modifyType" @blur="inpuSizeCheck(v3.distance, k3, carTwosArr)"></el-input-number>
                  </div>
                  <div>
                    <span>米</span>
                    <b>：</b>
                    <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0"
                      :disabled="modifyType"></el-input-number>
                    <span>元/方</span>
                  </div>
                </div>
                <div>
                  <el-button v-if="carTwosArr.length - 2 == k3" class="bottom_text" :disabled="modifyType"
                    @click="addJson()">添加区间</el-button>
                  <el-button v-else class="bottom_text" :disabled="modifyType" @click="delJson(k3)">删除区间</el-button>
                </div>
              </div>
              <div v-if="k3 == carTwosArr.length - 1" class="liBox2" style="width: 100%">
                <div>
                  <span>大于</span>
                  <el-input-number v-model="carTwosArr[k3 - 1].distance" size="mini" :controls="false" :precision="2"
                    disabled></el-input-number>
                </div>
                <div>
                  <span>米</span>
                  <b>：</b>
                  <span>每增加</span>
                  <el-input-number v-model="v3.addDistance" size="mini" :controls="false" :min="0" style="width: 80px"
                    :disabled="modifyType"></el-input-number>
                  <span>米，增加</span>
                  <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0" style="width: 80px"
                    :disabled="modifyType"></el-input-number>
                  <span>元/方</span>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="固定值" name="固定值">
            <div v-for="(v3, k3) in carTwosArr" :key="k3">
              <div v-if="k3 == 0" class="liBox1">
                <div>
                  <span>小于等于</span>
                  <el-input-number v-model="v3.distance" style="width:50%" size="mini" :controls="false" :precision="2"
                    :disabled="modifyType" @blur="inpuSizeCheck(v3.distance, k3, carTwosArr)"></el-input-number>
                </div>
                <div>
                  <span>米</span>
                  <b>：</b>
                  <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0"
                    :disabled="modifyType"></el-input-number>
                  <span>元/方</span>
                </div>
              </div>
              <div v-if="k3 > 0 && k3 != carTwosArr.length - 1" class="liBox3">
                <div>
                  <div>
                    <el-input-number v-model="carTwosArr[k3 - 1].distance" size="mini" :controls="false" :precision="2"
                      disabled></el-input-number>
                    <span>至</span>
                    <el-input-number v-model="v3.distance" size="mini" :controls="false" :precision="2"
                      :disabled="modifyType" @blur="inpuSizeCheck(v3.distance, k3, carTwosArr)"></el-input-number>
                  </div>
                  <div>
                    <span>米</span>
                    <b>：</b>
                    <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0"
                      :disabled="modifyType"></el-input-number>
                    <span>元/方</span>
                  </div>
                </div>
                <div>
                </div>
              </div>
              <div v-if="k3 == carTwosArr.length - 1" class="liBox2" style="width: 100%">
                <div>
                  <span>大于</span>
                  <el-input-number v-model="carTwosArr[k3 - 1].distance" size="mini" :controls="false" :precision="2"
                    disabled></el-input-number>
                </div>
                <div>
                  <span>米</span>
                  <b>：</b>
                  <span>每增加</span>
                  <el-input-number v-model="v3.addDistance" size="mini" :controls="false" :min="0" style="width: 80px"
                    :disabled="modifyType"></el-input-number>
                  <span>米，增加</span>
                  <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0" style="width: 80px"
                    :disabled="modifyType"></el-input-number>
                  <span>元/方</span>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="basePriceListType = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="basePriceListUpFun()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 业务管控点 -->
    <el-dialog v-dialogDrag :visible.sync="controlPoint_Dialog" width="800px">
      <span slot="title" class="dialog-title">管控业务点设置</span>
      <div class="dialoginfo">
        <div class="FZYguanKongYeWuDian">
          <table>
            管控业务点：
          </table>
          <div class="FZYcheckbox">
            <div v-if="formDate.processModel == 1">
              <el-checkbox v-for="(v, k) in businessCheckbox" :key="k" :label="v.id" :disabled="true" checked>{{
                v.itemName }}</el-checkbox>
            </div>
            <el-checkbox-group v-else v-model="formDate.business">
              <el-checkbox v-for="(v, k) in businessCheckbox" :key="k" :label="v.id" :disabled="modifyType">{{ v.itemName
              }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all" style="margin-left: 24px" @click="controlPoint_Dialog = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 站点运输价及到岸价查看 -->
    <el-dialog v-dialogDrag :visible.sync="thePrice_Dialog" width="550px">
      <span slot="title" class="dialog-title">站点运输价及到岸价</span>
      <div class="dialoginfo"></div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="thePrice_Dialog = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 协作单位 -->
    <el-dialog v-dialogDrag :visible.sync="cooperativeUnit_Dialog" width="550px">
      <span slot="title" class="dialog-title">协作单位</span>
      <div class="dialoginfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="cooperativeUnitArr" tooltip-effect="dark">
          <el-table-column label="协作单位" align="center" prop="name"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="cooperativeUnit_Dialog = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 合同产品列表 -->
    <el-dialog v-dialogDrag :visible.sync="riseInPriceQueryOneByidType" width="800px">
      <span slot="title" class="dialog-title">合同产品列表</span>
      <div class="dialoginfo">
        <div class="form-title">设备价格</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="cplistArr" tooltip-effect="dark" class="FZYselectList">
          <el-table-column label="泵车类型" align="center" width="250">
            <template slot-scope="scope">
              <el-select v-if="formDate.facilityType == 1" v-model="scope.row.deviceId" size="mini" placeholder="选择"
                disabled style="width: 100% !important">
                <el-option v-for="item in pumpTypeArr" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
              </el-select>
              <el-input v-else v-model="scope.row.deviceName" size="mini" style="width: 100%" placeholder="输入设备"
                disabled />
            </template>
          </el-table-column>
          <el-table-column :label="columnList" align="center">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false" @click="QueryOneByidFun(scope.row, true)">价格设置</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="formDate.isPumpLine == 1" class="form-title">泵管价格</div>
        <el-table v-if="formDate.isPumpLine == 1" :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="pumpListArr"
          tooltip-effect="dark" class="FZYselectList">
          <el-table-column label="泵管类型" align="center" width="250">
            <template slot-scope="scope">
              <el-select v-model="scope.row.pumpTypeId" size="mini" placeholder="选择" disabled
                style="width: 100% !important">
                <el-option v-for="item in pumpTubeArr" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="基础单价（元/方）" align="center">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false" @click="QueryOneByidFun(scope.row, false)">价格设置</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="riseInPriceQueryOneByidType = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 价格设置-调价详情 -->
    <el-dialog v-dialogDrag :visible.sync="QueryOneByidType" width="800px">
      <span slot="title" class="dialog-title">价格设置</span>
      <div class="dialoginfo">
        <div v-show="$options.filters.moneyFun(formDate.facilityType, moneyType)" class="FZY1-3"
          style="border-bottom: 0px; margin-bottom: 10px">
          <div v-for="(v3, k3) in carTwosArr" :key="k3">
            <div v-if="k3 == 0" class="liBox1">
              <div>
                <span>小于</span>
                <el-input-number v-model="v3.maxDistance" size="mini" :controls="false" :precision="2"
                  disabled></el-input-number>
              </div>
              <div>
                <span>米</span>
                <b>：</b>
                <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0"
                  :disabled="modifyType"></el-input-number>
                <span>元/方</span>
              </div>
            </div>
            <div v-if="k3 > 0 && k3 != carTwosArr.length - 1" class="liBox3">
              <div>
                <div>
                  <el-input-number v-model="v3.minDistance" size="mini" :controls="false" :precision="2"
                    :disabled="modifyType" @change="carTwosArr[k3 - 1].maxDistance = v3.minDistance"
                    @blur="inpuSizeCheck2(v3.minDistance, k3, carTwosArr)"></el-input-number>
                  <span>至</span>
                  <el-input-number v-model="v3.maxDistance" size="mini" :controls="false" :precision="2"
                    disabled></el-input-number>
                </div>
                <div>
                  <span>米</span>
                  <b>：</b>
                  <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0"
                    :disabled="modifyType"></el-input-number>
                  <span>元/方</span>
                </div>
              </div>
              <div>
                <el-button v-if="carTwosArr.length - 2 == k3" class="bottom_text" :disabled="modifyType"
                  @click="addJson()">添加区间</el-button>
                <el-button v-else class="bottom_text" :disabled="modifyType" @click="delJson(k3)">删除区间</el-button>
              </div>
            </div>
            <div v-if="k3 == carTwosArr.length - 1" class="liBox2" style="width: 100%">
              <div>
                <span>大于</span>
                <el-input-number v-model="v3.minDistance" size="mini" :controls="false" :precision="2"
                  :disabled="modifyType" @change="carTwosArr[k3 - 1].maxDistance = v3.minDistance"
                  @blur="inpuSizeCheck2(v3.minDistance, k3, carTwosArr)"></el-input-number>
              </div>
              <div>
                <span>米</span>
                <b>：</b>
                <span>每增加</span>
                <el-input-number v-model="v3.addDistance" size="mini" :controls="false" :min="0" style="width: 80px"
                  :disabled="modifyType"></el-input-number>
                <span>米，增加</span>
                <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0" style="width: 80px"
                  :disabled="modifyType"></el-input-number>
                <span>元/方</span>
              </div>
            </div>
          </div>
        </div>
        <el-form ref="contractRawMoneySaveForm" label-width="80px" :model="contractRawMoneySaveForm"
          :rules="contractRawMoneySaveFormRules" class="FZYform2">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item v-if="!$options.filters.moneyFun(formDate.facilityType, moneyType)" label="价格" prop="money">
                <el-input v-model="contractRawMoneySaveForm.money" type="Number" placeholder :controls="false">
                  <template slot="append">元/方</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生效日期" prop="startTime">
                <el-date-picker v-model="contractRawMoneySaveForm.startTime" type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div style="margin-left: 24px">
                <FileComponent2 fileCode="contractFile" :files="files2" @deleteFile="deleteFile2"
                  @uplodeSuccess="uplodeSuccess2" />
              </div>
            </el-col>
            <el-col :span="2" style="margin-bottom: 20px">
              <el-button class="bottom_all" @click="contractRawMoneySaveFun()">添加</el-button>
            </el-col>
          </el-row>
        </el-form>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="QueryOneByidArr" tooltip-effect="dark">
          <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
          <el-table-column label="价格" prop="money" align="center">
            <template slot-scope="scope">
              <el-link v-if="$options.filters.moneyFun(formDate.facilityType, moneyType)" class="table_link"
                :underline="false" @click="basePriceListFun2(scope.row)">查看</el-link>
              <span v-else>{{ scope.row.money }} 元/方</span>
            </template>
          </el-table-column>
          <el-table-column label="生效日期" prop="startTime" align="center"></el-table-column>
          <el-table-column label="附件" align="center" width="120">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_all_two" @click="lookFile(scope)">查看</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="120">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false" @click="contractRawMoneyDeletesFun(scope.row)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="!$options.filters.moneyFun(formDate.facilityType, moneyType)" class="card_bottom">
          <div class="card_bottom_left">
            <div class="top_page_totle">总共{{ QueryOneByidObject.total }}条</div>
            <el-pagination :current-page.sync="QueryOneByidObject.page" :page-size="QueryOneByidObject.pageSize"
              layout="prev, pager, next, jumper" :total="QueryOneByidObject.total"
              @current-change="QueryOneByidFun()"></el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="QueryOneByidType = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 价格区间弹窗 -->
    <el-dialog v-dialogDrag :visible.sync="basePriceListType2" width="800px">
      <span slot="title" class="dialog-title">泵送高度及价格</span>
      <div class="dialoginfo FZY1-3">
        <div v-for="(v3, k3) in carTwosArr2" :key="k3">
          <div v-if="k3 == 0" class="liBox1">
            <div>
              <span>小于</span>
              <el-input-number v-model="v3.maxDistance" size="mini" :controls="false" :precision="2"
                disabled></el-input-number>
            </div>
            <div>
              <span>米</span>
              <b>：</b>
              <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0" disabled></el-input-number>
              <span>元/方</span>
            </div>
          </div>
          <div v-if="k3 > 0 && k3 != carTwosArr2.length - 1" class="liBox3">
            <div>
              <div>
                <el-input-number v-model="v3.minDistance" size="mini" :controls="false" :precision="2"
                  disabled></el-input-number>
                <span>至</span>
                <el-input-number v-model="v3.maxDistance" size="mini" :controls="false" :precision="2"
                  disabled></el-input-number>
              </div>
              <div>
                <span>米</span>
                <b>：</b>
                <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0" disabled></el-input-number>
                <span>元/方</span>
              </div>
            </div>
          </div>
          <div v-if="k3 == carTwosArr2.length - 1" class="liBox2" style="width: 100%">
            <div>
              <span>大于</span>
              <el-input-number v-model="carTwosArr2[k3 - 1].maxDistance" size="mini" :controls="false" :precision="2"
                disabled></el-input-number>
            </div>
            <div>
              <span>米</span>
              <b>：</b>
              <span>每增加</span>
              <el-input-number v-model="v3.addDistance" size="mini" :controls="false" :min="0" style="width: 80px"
                disabled></el-input-number>
              <span>米，增加</span>
              <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0" style="width: 80px"
                disabled></el-input-number>
              <span>元/方</span>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="basePriceListType2 = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 开户信息 -->
    <el-dialog v-dialogDrag :visible.sync="AllqueryListsByPid" width="550px">
      <span slot="title" class="dialog-title">开户信息维护</span>
      <div class="dialoginfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="queryListsByPidArr" tooltip-effect="dark">
          <el-table-column label="单位名称" prop="name" align="center"></el-table-column>
          <el-table-column label="开户信息">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false"
                @click="contractAccountGetDetailFun(scope.row.id, scope.$index + 1)">开户信息</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="AllqueryListsByPid = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 开户信息详情-编辑 -->
    <el-dialog v-dialogDrag :visible.sync="contractAccountGetDetailType" width="800px">
      <span slot="title" class="dialog-title">开户信息</span>
      <div class="dialoginfo">
        <el-form ref="contractAccountSaveForm" label-width="130px" :model="contractAccountSaveForm"
          :rules="contractAccountSaveRules" class="FZYform2">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="法定代表人" prop="name" :rules="[{ required: true, message: '请输入法定人', trigger: 'blur' }]">
                <el-input v-model="contractAccountSaveForm.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="法人身份证号码" prop="identityCard">
                <el-input v-model="contractAccountSaveForm.identityCard"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="合同条款" prop="contractPact"
                :rules="[{ required: true, message: '请输入合同条款', trigger: 'blur' }]">
                <el-input v-model="contractAccountSaveForm.contractPact"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="统一社会信用代码" prop="unifiedSocialCreditCode"
                :rules="[{ required: true, message: '请输入信用代码', trigger: 'blur' }]">
                <el-input v-model="contractAccountSaveForm.unifiedSocialCreditCode"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="收款方式">
                <div style="width: 100px">现金</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位开户银行">
                <el-input v-model="contractAccountSaveForm.bankDepositA"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="单位开户账号">
                <el-input v-model="contractAccountSaveForm.accountA"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户银行联行号">
                <el-input v-model="contractAccountSaveForm.bankNumberA"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="收款方式">
                <div style="width: 100px">电子承兑</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位开户银行">
                <el-input v-model="contractAccountSaveForm.bankDepositB"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="单位开户账号">
                <el-input v-model="contractAccountSaveForm.accountB"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户银行联行号">
                <el-input v-model="contractAccountSaveForm.bankNumberB"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="收款方式">
                <div style="width: 100px">商票</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位开户银行">
                <el-input v-model="contractAccountSaveForm.bankDepositC"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="单位开户账号">
                <el-input v-model="contractAccountSaveForm.accountC"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户银行联行号">
                <el-input v-model="contractAccountSaveForm.bankNumberC"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="收款方式">
                <div style="width: 100px">其他</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位开户银行">
                <el-input v-model="contractAccountSaveForm.bankDepositD"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="单位开户账号">
                <el-input v-model="contractAccountSaveForm.accountD"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户银行联行号">
                <el-input v-model="contractAccountSaveForm.bankNumberD"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="contractAccountGetDetailType = false">关 闭</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="contractAccountSaveFun()">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 总结算 -->
    <el-dialog v-dialogDrag :visible.sync="allSum" width="1200px">
      <span slot="title" class="dialog-title">总结算</span>
      <div class="dialoginfo">
        <div style="margin: 10px 0;">结算单数据</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="allSumData.details" tooltip-effect="dark" :span-method="objectSpanMethod1">
          <el-table-column label="结算周期" prop="settleTime" align="center"></el-table-column>
          <el-table-column label="协作单位" prop="cooperationUnit" align="center"> </el-table-column>
          <el-table-column label="结算金额（元）" prop="settleMoney" align="center"></el-table-column>
        </el-table>
        <div style="margin: 10px 0;">总结算数据</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="allSumData.totals" tooltip-effect="dark">
          <el-table-column label="协作单位" prop="cooperationUnit" align="center"></el-table-column>
          <el-table-column label="总结算金额（元）" prop="settleMoneyTotal" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.settleMoneyTotal" :disabled="currenindex == 3" type="Number" placeholder>
                <template slot="append">元/吨</template>
              </el-input>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <div style="margin: 10px 0;">备注</div>
          <el-input v-model="allSumData.remark" type="text" :disabled="currenindex == 3" placeholder='请输入备注'></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="allSum = false">关 闭</el-button>
        <el-button v-if="currenindex != 3" class="bottom_all" @click="saveGeneral">保 存</el-button>
      </span>
    </el-dialog>
    <ModifyTheRecord ref="ModifyTheRecord"></ModifyTheRecord>
    <diaLog1 :dialog="dialog1" :low="low" :supplierId="supplierId" :tableData="roleList" @reset="reset1" @submit="submit">
    </diaLog1>
    <!-- 查看附件 -->
    <LookFile :visible.sync="lookFileVisible" :config="lookFileConfig" />
  </div>
</template>

<script>
import FileComponent2 from "@/views/platform/ICPS/internetSales/components/fileComponent";
import LookFile from "@/components/File/LookFile";
import mixin from "@/mixins/ICPSmixin.js";
import FileComponent from "@/components/File/fileComponent";
import { contractTotalSettle, generalSaveOrUpdate, queryList } from "@/api/GHnumber/allSum.js";
import {
  queryPage,
  batchUpdateOrDelete,
  updateSortNum,
  saveOrUpdate,
  Download,
  // engineeringManagementQueryPage,
  processes_collection,
  contractSaveOrUpdate,
  contractQueryDetailById,
  QueryOneByid,
  contractRawMoneySave,
  contractRawMoneyDeletes,
  contractAccountGetDetail,
  contractAccountSave,
  PumpPriceLogQueryPage,
  PumpPriceLogSave,
  PumpPriceLogGetDetail,
  PumpPriceLogDeletes,
  queryContractNumber,
} from "@/api/GHnumber/car.js";
import { querysupplierPage, queryListsByPid } from "@/api/GHnumber/supplier.js";
import { queryMaterialsPage } from "@/api/basicConfig/Rmaterial.js";
import { getDicType, getDicsType } from "@/api/common.js";
import { getUserInfo } from "@/utils/auth.js";
import { getUserAutList } from "@/api/common.js";
import ModifyTheRecord from "./modifyTheRecord";
import { getOrganizationBytypes } from "@/api/internetSales/chanceManagement";
const diaLog1 = () => import("../dialog/contract1");
export default {
  components: { FileComponent, ModifyTheRecord, diaLog1, FileComponent2, LookFile },
  mixins: [mixin],
  props: ['currenindex'],
  watch: {
    "formDate.startDayendDay"() {
      this.formDate.startDay = this.formDate.startDayendDay[0];
      this.formDate.endDay = this.formDate.startDayendDay[1];
    },
    yiFenPeiRadio: {
      handler: function (val) {
        this.ids = [val.id];
      },
      deep: false,
    },
  },
  data() {
    var userCard = (rule, value, callback) => {
      //验证身份证号码
      var reg = new RegExp(/^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/);
      if (!reg.test(value)) {
        callback(new Error("请输入正确的身份证号码"));
      } else {
        callback();
      }
    };
    return {
      //分配账号角色列表
      roleList: [
        { roleName: "设备外包接单员", roleId: "194993399189868544", list: [], list1: [] },
        { roleName: "设备外包签票员", roleId: "194994258393042944", list: [], list1: [] },
        { roleName: "设备外包结算员", roleId: "194995014869323776", list: [], list1: [] },
        { roleName: "设备外包异常处理员", roleId: "194995864048111616", list: [], list1: [] },
      ],
      roadWorkList: [], // 合同签订主体数据
      lookFileVisible: false,
      lookFileConfig: {},
      low: "",
      dialog1: false,
      UserInfo: "",
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      batchUpdateOrDelete: batchUpdateOrDelete, //启用禁用接口
      updateSortNum: updateSortNum,
      saveOrUpdate: saveOrUpdate,
      DownloadURL: Download,
      /*表格数据*/
      table: [
        { label: "合同ID", width: "120", prop: "code", status: true },
        { label: "合同类型", width: "120", prop: "contractType", status: true },
        {
          label: "合同签订主体",
          width: "auto",
          prop: "contractSigningSubject",
          status: true,
        },
        {
          label: "站点名称",
          width: "auto",
          prop: "mainCompany",
          status: true,
        },
        {
          label: "主合同单位",
          width: "auto",
          prop: "supplierName",
          status: true,
        },
        {
          label: "供应商类别",
          width: "120",
          prop: "supplierType",
          status: true,
        },
        {
          label: "合同编号",
          width: "auto",
          prop: "contractNumber",
          status: true,
        },
        {
          label: "合同签订情况",
          width: "auto",
          prop: "concludeAndSignStatus",
          status: true,
        },
        {
          label: "华西云采注册情况",
          width: "120",
          prop: "loginStatus",
          status: true,
        },
        { label: "合同有效期", width: "145", prop: "startDay", status: true },
        {
          label: "招标编号",
          width: "120",
          prop: "callForBidsNumber",
          status: true,
        },
        {
          label: "合作等级",
          width: "auto",
          prop: "cooperationClass",
          status: true,
        },
        { label: "状态", width: "120", prop: "", status: true },
        { label: "操作", width: "100", prop: "", status: true, fixed: "right" },
      ],
      modifyType: false, //修改是否可以状态
      text: "含水率规则：0≤x≤5%，按照5%结算；5%＜X≤8%，按照8%结算；8%<x≤13%，按照实测结算；13%<x，按照实测结算，并5元/吨处罚",
      clearingFromIdList: [
        // { id: '0', name: '双控' },
        // { id: '1', name: '图算' },
        { id: "2", name: "实结" },
      ], //结算方式
      companylist: [], //甲方公司
      sitelist: [], //站点名称
      supplierList: [], //主合同单位名称
      MaterialsList: [], //原物料
      AForContract: [], //是否甲供合同
      theUnitPriceSource: [
        {
          id: "1",
          itemName: "已信息价结算",
        },
        {
          id: "2",
          itemName: "已内部价结算",
        },
        {
          id: "3",
          itemName: "已市场价结算",
        },
        {
          id: "4",
          itemName: "已出厂价结算",
        },
        {
          id: "5",
          itemName: "已到岸价结算",
        },
      ], //单价来源
      engineeringManagement: [], //甲供工程
      thePrice_Dialog: false, //价格表弹窗
      controlPoint_Dialog: false, //业务管控点弹窗
      cooperativeUnit_Dialog: false, //协作单位弹窗
      rules: {
        firstPartyId: [{ required: true, message: "请选择甲方公司", trigger: "change" }],
        contractSigningSubjectId: [{ required: true, message: "请选择合同签订主体", trigger: "change" }],
        supplierId: [{ required: true, message: "请选择主合同单位", trigger: "change" }],
        contractNumber: [{ required: true, message: "请输入合同编号", trigger: "change" }],
        callForBidsNumber: [{ required: true, message: "请输入招标编号", trigger: "change" }],
        concludeAndSignStatus: [{ required: true, message: "请选择合同签订情况", trigger: "change" }],
        loginStatus: [
          {
            required: true,
            message: "请选择华西云采注册情况",
            trigger: "change",
          },
        ],
        linkman: [{ required: true, message: "请输入联系人", trigger: "change" }],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "change" },
          { min: 11, max: 11, message: "手机号格式错误", trigger: "change" },
        ],
        startDayendDay: [{ required: true, message: "请选择合同有效期", trigger: "change" }],
        dataType: [{ required: true, message: "泵送队标识", trigger: "change" }],
        clearingFormId: [{ required: true, message: "请选择结算方式", trigger: "change" }],
        processModel: [{ required: true, message: "请选择流程模式", trigger: "change" }],
        taxRate: [{ required: true, message: "请输入税率", trigger: "change" }],
      },
      formDate: {
        userType: [],
        stationsList: [],
        stations: "",
        startDayendDay: [],
        id: "",
        oilPrice: "",
        contractTypeId: "3",
        contractType: "设备外包",
        deviceId: 1,
        facilityType: 1,
        contractSigningSubjectId: "", // 合同签订主体
        firstParty: "", //甲方
        supplierName: "", //供应商
        supplierTypeId: "", //供应商类型id
        userId: "",
        userName: "",
        firstSupplyName: "", //甲供合同
        clearingSource: "", //结算原
        clearingForm: "", //结算方式
        accessory: [], //附件
        cooperationClass: "合作等级", //甲方公司里面出来的
        cooperationClassId: "合作等级id", //甲方公司里面出来的
        business: [], //业务点1，2，3
        dlist: [], //设备表格价格+区间
        aplist: [], //泵车表格价格
        dataType: 1,
      },
      businessCheckbox: [], //业务点
      cooperativeUnitArr: [], //外协单位列表
      riseInPriceQueryOneByidType: false,
      riseInPriceQueryOneByidArr: [], //调价列表
      contractId: "", //原物料列表
      QueryOneByidType: false,
      QueryOneByidArr: [], //调价列表
      pumpTypeArr: [], //非运输货物原物料list
      cargoTypeIdArr: [
        {
          id: 1,
          name: "原物料",
        },
        {
          id: 2,
          name: "混凝土",
        },
        {
          id: 3,
          name: "其他",
        },
      ],
      QueryOneByidObject: {
        //调价分页
        page: 1,
        pageSize: 10,
        total: 0,
      },
      contractRawMoneySaveForm: { startTime: "" },
      contractRawMoneySaveFormRules: {
        money: [{ required: true, message: "请输入价格", trigger: "blur" }],
        startTime: [{ required: true, message: "请选择生效日期", trigger: "blur" }],
      },
      AllqueryListsByPid: false,
      queryListsByPidArr: [], //开户信息-协作单位合并列表
      contractAccountGetDetailType: false,
      //开户信息表单
      contractAccountSaveForm: {
        contractPactId: "", //合同条约id
        contractPact: "", //合同条约
      },
      contractAccountSaveRules: {
        identityCard: [{ required: true, validator: userCard, trigger: "change" }], //身份证
      },
      columnList: "泵送高度及价格",
      cplistArr: [], //供应产品列表显示部分
      carTwosArr: [], //区间价格弹窗数组
      carTwosArrIndex: "", //当前打开的价格弹窗数组对应的表格里面的下标
      basePriceListType: false, //设置区间价格弹窗
      basePriceListType2: false, //区间价格仅仅查看的弹窗
      carTwosArr2: [], //区间价格弹窗数组
      pumpListArr: [], //泵管价格
      moneyType: false, //当前是否打开的是泵车价格
      files: [],
      files2: [],
      yiFenPeiRadio: "",
      supplierId: "",
      taxRateList: [],
      rangeFixedType: '区间',//区间/固定值类型

      allSum: false,//总结算
      allSumData: {
        contractId: "",
        details: [],
        totals: [],
        remark: ""
      },//总结算数据
      allSumDataCopy: {
        contractId: "",
        details: {},
        totals: {},
        remark: ""
      }
    };
  },
  async created() {
    this.UserInfo = await getUserInfo();
    this.companylist = await getUserAutList();
    const arr = this.companylist.map(item => item.children);
    arr.forEach(item => {
      item.forEach(sItem => {
        this.sitelist.push(sItem);
      });
    });
    let params = {
      page: 1,
      pageSize: 99999,
    };
    // engineeringManagementQueryPage({
    //   isAssess: 1,
    //   page: 1,
    //   pageSize: 99999,
    // }).then(res => {
    //   this.engineeringManagement = res.data.data;
    // });
    getDicType({ code: "pumpTube" }).then(res => {
      this.pumpTubeArr = res.data.items; //
    });
    getDicType({ code: "castingType" }).then(res => {
      this.pumpTypeArr = res.data.items; //
    });
    querysupplierPage(params).then(res => {
      this.supplierList = res.data.data;
    });
    queryMaterialsPage().then(res => {
      this.MaterialsList = res.data;
    });
    getDicType({ code: "contractType" }).then(res => {
      this.contractTypeArry = res.data.items; //
    });
    getDicType({ code: "HuaXiYunCai_Registration" }).then(res => {
      this.HuaXiYunCai_RegistrationArry = res.data.items; //
    });
    getDicType({ code: "AForContract" }).then(res => {
      this.AForContract = res.data.items; //
    });
    getOrganizationBytypes({ typeId: "19da56b9e85648059e3cf1e7da497da4,110572600018735104" }).then(res => {
      if (res.code === 1001) {
        this.roadWorkList = res.data;
      }
    });
    getDicType({ code: "hetongsuilv" }).then(res => {
      this.taxRateList = res.data.items;
      this.taxRateList.forEach(item => {
        item.itemValue = Number(item.itemValue);
      });
    });
  },
  methods: {
    objectSpanMethod1({ row, columnIndex }) {
      if (columnIndex == 0) {
        return [row.rowspan, row.colspan];
      }
    },
    /* 保存总结算 */
    saveGeneral() {
      for (let k in this.allSumDataCopy.totals) {
        var arr = this.allSumData.totals.filter(e => {
          return e.cooperationUnitId == k
        })
        this.allSumDataCopy.totals[k].settleMoneyTotal = arr[0].settleMoneyTotal
      }
      this.allSumDataCopy.remark = this.allSumData.remark
      generalSaveOrUpdate(this.allSumDataCopy).then(res => {
        if (res.code == 1001) {
          this.$message.success('操作成功')
          this.gettableData();
          this.allSum = false;
        }
      })
    },

    /* 生成总结算 */
    allsumHand() {
      this.allSumData = this.$options.data().allSumData
      if (this.currenindex == 3) {
        queryList({ contractId: this.ids[0] }).then(res => {
          if (res.code == 1001) {
            // this.allSumDataCopy = this.copy(res.data)
            this.allSumData.contractId = res.data.contractId
            this.allSumData.remark = res.data.remark
            let details = res.data.details
            let totals = res.data.totals
            for (let k in details) {
              let length = details[k].length
              details[k].forEach((m, n) => {
                if (n === 0) {
                  m.rowspan = length
                  m.colspan = 1
                } else {
                  m.rowspan = 0
                  m.colspan = 0
                }
              })
              this.allSumData.details.push(...details[k])
            }
            for (let k in totals) {
              this.allSumData.totals.push(totals[k])
            }
            console.log(this.allSumData)
            this.allSum = true
          }
        })
      } else {
        contractTotalSettle({ contractId: this.ids[0] }).then(res => {
          if (res.code == 1001) {
            this.allSumDataCopy = this.copy(res.data)
            this.allSumData.contractId = res.data.contractId
            this.allSumData.remark = res.data.remark
            let details = res.data.details
            let totals = res.data.totals
            for (let k in details) {
              let length = details[k].length
              details[k].forEach((m, n) => {
                if (n === 0) {
                  m.rowspan = length
                  m.colspan = 1
                } else {
                  m.rowspan = 0
                  m.colspan = 0
                }
              })
              this.allSumData.details.push(...details[k])
            }
            for (let k in totals) {
              this.allSumData.totals.push(totals[k])
            }
            console.log(this.allSumData)
            this.allSum = true
          }
        })
      }

    },
    compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;  //降序只需要  return value2- value1
      }
    },
    //设置固定值
    setFixedValue() {
      if (this.rangeFixedType == '固定值') {
        this.carTwosArr = [
          {
            id: "",
            distance: 999, //距离
            price: 0, //价格
            addDistance: 0, //每增加距离
            type: 1, //1新增，2修改，0删除
          },
          {
            id: "",
            distance: 1000, //距离
            price: 0, //价格
            addDistance: 0, //每增加距离
            type: 1, //1新增，2修改，0删除
          },
          {
            id: "",
            distance: 9999999, //距离
            price: 0, //价格
            addDistance: 0, //每增加距离
            type: 1, //1新增，2修改，0删除
          },
        ]
      } else {
        this.carTwosArr = [
          {
            id: "",
            distance: 1, //距离
            price: 0, //价格
            addDistance: 0, //每增加距离
            type: 1, //1新增，2修改，0删除
          },
          {
            id: "",
            distance: 2, //距离
            price: 0, //价格
            addDistance: 0, //每增加距离
            type: 1, //1新增，2修改，0删除
          },
          {
            id: "",
            distance: 9999999, //距离
            price: 0, //价格
            addDistance: 0, //每增加距离
            type: 1, //1新增，2修改，0删除
          },
        ]
      }

    },
    lookFile({ row }) {
      this.lookFileVisible = true;
      this.lookFileConfig = row;
    },
    /**分配账号*/
    open(low, key) {
      this.supplierId = low.supplierId;
      this.low = low.id;
      this[key] = true;
    },
    reset1(key) {
      this[key] = false;
    },
    submit(key) {
      this[key] = false;
    },
    /**
     * @Description: 删除附件
     * @Param:
     * @Author: wangwangwang
     */
    deleteFile(index) {
      this.files.splice(index, 1);
    },
    deleteFile2(index) {
      this.files2.splice(index, 1);
    },
    /**
     * @Description: 上传成功
     * @Param:
     * @Author: wangwangwang
     */
    uplodeSuccess(data) {
      this.files.push(data);
    },
    uplodeSuccess2(data) {
      const params = {
        name: data.fileName,
        fileName: data.fileName,
        fileUrl: data.fileUrl,
        path: data.fileUrl,
        fileType: 1,
        type: 1,
        createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      };
      this.files2.push(params);
    },
    //暂存价格区间设置
    basePriceListUpFun() {
      /**判断区间范围是否正确--开始 */
      let type1 = false;
      let arr1 = this.carTwosArr;
      console.log(arr1)
      arr1.forEach((v, k) => {
        if (k > 0 && v.distance - arr1[k - 1].distance <= 0) {
          type1 = true;
        }
      });
      console.log(JSON.parse(JSON.stringify(arr1)), type1);
      /**判断区间范围是否正确--结束 */
      if (type1) {
        this.$message({
          message: "区间值范围不正确，请检查！",
          type: "warning",
        });
      } else {
        this.basePriceListType = false;
        this.cplistArr[this.carTwosArrIndex].list = this.carTwosArr;
        console.log(JSON.parse(JSON.stringify(this.cplistArr)));
      }
    },
    //价格区间设置打开
    basePriceListFun(d, index) {
      this.basePriceListType = true;
      this.rangeFixedType = '区间'
      this.carTwosArr = JSON.parse(JSON.stringify(d));
      console.log(this.carTwosArr)
      this.carTwosArrIndex = index;
    },
    facilityTypeFun() {
      this.cplistArr = [
        {
          id: "",
          deviceName: "", //设备名称
          deviceId: "", //设备id
          basePrice: 0, //单价
          assessmentPrice: 0, //考核价
          type: 1,
          list: [
            {
              id: "",
              distance: 1, //距离
              price: 0, //价格
              addDistance: 0, //每增加距离
              type: 1, //1新增，2修改，0删除
            },
            {
              id: "",
              distance: 2, //距离
              price: 0, //价格
              addDistance: 0, //每增加距离
              type: 1, //1新增，2修改，0删除
            },
            {
              id: "",
              distance: 9999999, //距离
              price: 0, //价格
              addDistance: 0, //每增加距离
              type: 1, //1新增，2修改，0删除
            },
          ],
        },
      ];
      if (this.formDate.facilityType == 1) {
        this.columnList = "泵送高度及价格";
      } else {
        this.columnList = "基础单价（元/方）";
      }
    },
    addJson() {
      //价格区间添加
      this.carTwosArr.splice(this.carTwosArr.length - 1, 0, {
        id: "",
        distance: 0,
        singleDistance: 1, //距离
        price: 0,
        singleDistancePrice: 0, //价格
        type: 1, //1新增；2修改 0删除
      });
      this.$forceUpdate();
    },
    delJson(k) {
      //价格区间删除
      this.carTwosArr.splice(k, 1);
      this.$forceUpdate();
    },
    //泵列表选择后赋值泵类型
    pumpTypeId_pumpTypeFun(e, k) {
      let type = false;
      this.pumpListArr.findIndex((v, index) => {
        if (v.pumpTypeId == e.pumpTypeId && k != index) {
          type = true;
        }
      });
      if (type) {
        this.$message({
          message: "该泵管已存在！",
          type: "warning",
        });
        e.pumpTypeId = "";
        return;
      }
      this.pumpListArr[k].pumpType = this.$fromatTable(this.pumpTypeArr, e.pumpTypeId, "id", "itemName");
    },
    //泵列表添加一条数据
    addItemPumpList() {
      this.pumpListArr.push({
        id: "",
        pumpType: "", //泵类型
        pumpTypeId: "", //泵类型id
        price: 0, //价格
        type: 1,
      });
      this.$forceUpdate();
    },
    deleteItemPumpList(index) {
      this.pumpListArr.splice(index, 1);
    },
    addItem() {
      //增加单价相关
      let data = {
        id: "",
        deviceName: "", //设备名称
        deviceId: "", //设备id
        basePrice: 0, //单价
        assessmentPrice: 0, //考核价
        type: 1,
        list: [
          {
            id: "",
            distance: 1, //距离
            price: 0, //价格
            addDistance: 0, //每增加距离
            type: 1, //1新增，2修改，0删除
          },
          {
            id: "",
            distance: 2, //距离
            price: 0, //价格
            addDistance: 0, //每增加距离
            type: 1, //1新增，2修改，0删除
          },
          {
            id: "",
            distance: 9999999, //距离
            price: 0, //价格
            addDistance: 0, //每增加距离
            type: 1, //1新增，2修改，0删除
          },
        ],
      };
      this.cplistArr.push(data);
      this.$forceUpdate();
    },
    deleteItem(index) {
      //删除单价相关
      this.cplistArr.splice(index, 1);
    },
    contractId_contractNoFun(e, k) {
      let type = false;
      this.cplistArr.findIndex((v, index) => {
        if (v.deviceId == e.deviceId && k != index) {
          type = true;
        }
      });
      if (type) {
        this.$message({
          message: "该设备已存在！",
          type: "warning",
        });
        e.deviceId = "";
        return;
      }
      this.cplistArr[k].deviceName = this.$fromatTable(this.pumpTypeArr, e.deviceId, "id", "itemName");
    },
    processModelFun() {
      this.formDate.business = [];
    },
    //获取已选择站点名称的业务点
    async stationsControlPointFun(type) {
      if (this.formDate.stationsList.length == 0) {
        this.$message({
          message: "请先选择站点！",
          type: "warning",
        });
        return;
      }
      if (this.formDate.processModel == undefined) {
        this.$message({
          message: "请先选择流程模式！",
          type: "warning",
        });
        return;
      }
      await getDicsType({
        codes: "collaboration,nomarket,personaluse,market",
      }).then(res => {
        this.businessCheckbox = [];
        res.data.market.items.forEach(v => {
          this.businessCheckbox.push(v);
        });
        if (!type) {
          this.controlPoint_Dialog = true;
          if (!this.formDate.id && this.formDate.processModel == 0) {
            processes_collection(this.formDate.stationsList).then(res2 => {
              if (res2.data?.length > 0) {
                this.formDate.business = res2.data.filter(dataRes => this.businessCheckbox.some(box => box.id == dataRes));
              }
            });
          }
        }
      });
    },
    //选择甲方公司后显示对应站点名称
    companylistChangeFun(type, companyId) {
      if (type) {
        this.formDate.stationsList = [];
      }
      this.sitelist = this.companylist.find(res => res.value == companyId).children;
    },
    //调用父级init
    init() {
      this.$emit("sumbit");
    },
    initt(data) {
      /*重置数据*/
      this.tableParam = data;
      this.gettableData();
    },
    srarch(data) {
      this.tableParam = data;
      this.gettableData();
    },
    //主合同单位选择后，带出对应参数
    async changemainCompanyId(e) {
      let item = this.supplierList.find(res => res.id == e);
      this.formDate.supplierType = item.typeName;
      this.formDate.supplierTypeId = item.typeId;
      this.formDate.dataType = item.typeId === "22069264211120128" ? 1 : 2;
    },
    /*添加保存*/
    // pagessubmitFromDate() {
    //   this.$refs.reffromDate.validate(valid => {
    //     if (valid) {
    //       let type = false;
    //       this.cplistArr.forEach(v => {
    //         if (this.formDate.facilityType == 1) {
    //           if (!v.deviceId) {
    //             type = true;
    //           }
    //         } else {
    //           if (!v.deviceName) {
    //             type = true;
    //           }
    //         }
    //       });
    //       if (type) {
    //         this.$message({
    //           message: "请检查表格数据是否完整！",
    //           type: "warning",
    //         });
    //         return;
    //       }
    //       //设备价格数据重组-开始
    //       // console.log(
    //       //   JSON.parse(JSON.stringify(this.formDate.dlist)),
    //       //   "原始"
    //       // );
    //       // console.log(JSON.parse(JSON.stringify(this.cplistArr)), "可见");
    //       if (this.cplistArr.length > 0 && this.formDate.dlist.length > 0) {
    //         let arr1_1 = [];
    //         //第一层对比开始,通过第一层自定义字段fzyId对比
    //         let alldata = this.cplistArr.filter(res => this.formDate.dlist.some(item => res.id == item.id));
    //         let deleteData = this.formDate.dlist.filter(res => !alldata.some(item => res.id == item.id));
    //         deleteData.forEach(res => {
    //           res.type = 0; //0是删除
    //         });
    //         let addData = this.cplistArr.filter(
    //           //新增的默认写死为 1；1
    //           res => !alldata.some(item => res.id == item.id)
    //         );
    //         arr1_1 = [...alldata, ...deleteData, ...addData];
    //         // console.log(
    //         //   JSON.parse(JSON.stringify(arr1_1)),
    //         //   "新的第一层对比后"
    //         // );
    //         console.log(JSON.parse(JSON.stringify(this.formDate.dlist)));
    //         arr1_1.forEach((v, k) => {
    //           this.formDate.dlist.forEach(v2 => {
    //             if (v.id == v2.id && v.list != null) {
    //               let alldata2 = v.list.filter(res => v2.list.some(item => res.id == item.id));
    //               alldata2.forEach(res => {
    //                 res.type = 2; //2是修改
    //               });
    //               let deleteData2 = v2.list.filter(res => !alldata2.some(item => res.id == item.id));
    //               deleteData2.forEach(res => {
    //                 res.type = 0; //0是删除
    //               });
    //               let addData2 = v.list.filter(res => !alldata2.some(item => res.id == item.id));
    //               arr1_1[k].list = [...alldata2, ...deleteData2, ...addData2];
    //             }
    //           });
    //         });
    //         this.formDate.dlist = arr1_1;
    //         // console.log(
    //         //   JSON.parse(JSON.stringify(this.formDate.dlist)),
    //         //   "最终组装后"
    //         // );
    //       } else {
    //         this.formDate.dlist = this.cplistArr;
    //       }
    //       this.formDate.dlist.forEach(item => {
    //         if (item.list?.length > 0) {
    //           item.list.sort(this.compare('distance'))
    //         }
    //       })
    //       //设备价格数据重组-结束
    //       if (this.formDate.facilityType == 1 && this.formDate.isPumpLine == 1) {
    //         let type = false;
    //         this.pumpListArr.forEach(v => {
    //           if (!v.pumpTypeId) {
    //             type = true;
    //           }
    //         });
    //         if (type) {
    //           this.$message({
    //             message: "请检查表格数据是否完整！",
    //             type: "warning",
    //           });
    //           return;
    //         }
    //         //泵管价格数据重组2-开始
    //         if (this.pumpListArr.length > 0 && this.formDate.aplist.length > 0) {
    //           let alldata = this.pumpListArr.filter(res => this.formDate.aplist.some(item => res.id == item.id));
    //           alldata.forEach(res => {
    //             res.type = 2; //0是删除
    //           });
    //           let deleteData = this.formDate.aplist.filter(res => !alldata.some(item => res.id == item.id));
    //           deleteData.forEach(res => {
    //             res.type = 0; //0是删除
    //           });
    //           let addData = this.pumpListArr.filter(res => !alldata.some(item => res.id == item.id));
    //           this.formDate.aplist = [...alldata, ...deleteData, ...addData];
    //         } else {
    //           this.formDate.aplist = this.pumpListArr;
    //         }
    //         //泵管价格数据重组2-结束
    //       }
    //       this.formDate.supplierName = this.$fromatTable(this.supplierList, this.formDate.supplierId, "id", "name");
    //       this.formDate.supplierTypeId = this.$fromatTable(this.supplierList, this.formDate.supplierId, "id", "typeId");
    //       this.formDate.clearingSource = this.$fromatTable(this.theUnitPriceSource, this.formDate.clearingSourceId, "id", "itemName");
    //       this.formDate.clearingForm = this.$fromatTable(this.clearingFromIdList, this.formDate.clearingFormId, "id", "name");
    //       this.formDate.cooperationClass = this.$fromatTable(this.supplierList, this.formDate.supplierId, "id", "gradeName");
    //       this.formDate.cooperationClassId = this.$fromatTable(this.supplierList, this.formDate.supplierId, "id", "gradeId");
    //       if (this.formDate.accessory.length != 0) {
    //         this.formDate.accessory = JSON.stringify(this.formDate.accessory);
    //       } else {
    //         this.formDate.accessory = "";
    //       }
    //       //站点数据重装-开始
    //       let stations = [];
    //       if (this.formDate.stationsList.length > 0) {
    //         let arr = [];
    //         this.formDate.stationsList.forEach(v => {
    //           this.sitelist.forEach(v2 => {
    //             if (v == v2.value) {
    //               arr.push({
    //                 id: v,
    //                 name: v2.label,
    //               });
    //             }
    //           });
    //         });
    //         stations = arr;
    //       }
    //       //站点数据重装-结束
    //       this.formDate.stations = JSON.stringify(stations);
    //       //业务点数据重组-开始
    //       let business = [];
    //       if (this.formDate.business.length > 0 || this.formDate.business != "[]") {
    //         let arr = [];
    //         this.formDate.business.forEach(v => {
    //           this.businessCheckbox.forEach(v2 => {
    //             if (v == v2.id) {
    //               arr.push({
    //                 id: v,
    //                 name: v2.itemName,
    //               });
    //             }
    //           });
    //         });
    //         business = arr;
    //       }
    //       this.formDate.accessory = JSON.stringify(this.files);
    //       const params = {
    //         ...this.formDate,
    //         business: JSON.stringify(business),
    //       };
    //       contractSaveOrUpdate(params).then(res => {
    //         if (res.code == 1001) {
    //           this.addDialog = false;
    //           this.$message.success("操作成功");
    //           this.init();
    //         }
    //       });
    //     } else {
    //       this.$message({
    //         message: "必填字段填写不完全！",
    //         type: "warning",
    //       });
    //       return false;
    //     }
    //   });
    // },
    /*添加保存*/
    pagessubmitFromDate() {
      this.$refs.reffromDate.validate(valid => {
        if (valid) {
          let type = false;
          this.cplistArr.forEach(v => {
            if (this.formDate.facilityType == 1) {
              if (!v.deviceId) {
                type = true;
              }
            } else {
              if (!v.deviceName) {
                type = true;
              }
            }
          });
          if (type) {
            this.$message({
              message: "请检查表格数据是否完整！",
              type: "warning",
            });
            return;
          }
          //设备价格数据重组-开始
          if (this.cplistArr.length > 0 && this.formDate.dlist.length > 0) {
            let arr1_1 = [];
            //第一层对比开始,通过第一层自定义字段fzyId对比
            let alldata = this.cplistArr.filter(res => this.formDate.dlist.some(item => res.id == item.id));
            let deleteData = this.formDate.dlist.filter(res => !alldata.some(item => res.id == item.id));
            deleteData.forEach(res => {
              res.type = 0; //0是删除
            });
            let addData = this.cplistArr.filter(
              //新增的默认写死为 1；1
              res => !alldata.some(item => res.id == item.id)
            );
            arr1_1 = [...alldata, ...deleteData, ...addData];
            arr1_1.forEach((v, k) => {
              this.formDate.dlist.forEach(v2 => {
                if (v.id == v2.id && v.list != null) {
                  let alldata2 = v.list.filter(res => v2.list.some(item => res.id == item.id));
                  alldata2.forEach(res => {
                    res.type = 2; //2是修改
                  });
                  let deleteData2 = v2.list.filter(res => !alldata2.some(item => res.id == item.id));
                  deleteData2.forEach(res => {
                    res.type = 0; //0是删除
                  });
                  let addData2 = v.list.filter(res => !alldata2.some(item => res.id == item.id));
                  arr1_1[k].list = [...alldata2, ...deleteData2, ...addData2];
                }
              });
            });
            this.formDate.dlist = arr1_1;
          } else {
            this.formDate.dlist = this.cplistArr;
          }
          this.formDate.dlist.forEach(item => {
            if (item.list?.length > 0) {
              item.list.sort(this.compare('distance'))
            }
          })
          //设备价格数据重组-结束
          if (this.formDate.facilityType == 1 && this.formDate.isPumpLine == 1) {
            let type = false;
            this.pumpListArr.forEach(v => {
              if (!v.pumpTypeId) {
                type = true;
              }
            });
            if (type) {
              this.$message({
                message: "请检查表格数据是否完整！",
                type: "warning",
              });
              return;
            }
            //泵管价格数据重组2-开始
            if (this.pumpListArr.length > 0 && this.formDate.aplist.length > 0) {
              let alldata = this.pumpListArr.filter(res => this.formDate.aplist.some(item => res.id == item.id));
              alldata.forEach(res => {
                res.type = 2; //2是修改
              });
              let deleteData = this.formDate.aplist.filter(res => !alldata.some(item => res.id == item.id));
              deleteData.forEach(res => {
                res.type = 0; //0是删除
              });
              let addData = this.pumpListArr.filter(res => !alldata.some(item => res.id == item.id));
              this.formDate.aplist = [...alldata, ...deleteData, ...addData];
            } else {
              this.formDate.aplist = this.pumpListArr;
            }
            //泵管价格数据重组2-结束
          }
          this.formDate.supplierName = this.$fromatTable(this.supplierList, this.formDate.supplierId, "id", "name");
          this.formDate.supplierTypeId = this.$fromatTable(this.supplierList, this.formDate.supplierId, "id", "typeId");
          this.formDate.clearingSource = this.$fromatTable(this.theUnitPriceSource, this.formDate.clearingSourceId, "id", "itemName");
          this.formDate.clearingForm = this.$fromatTable(this.clearingFromIdList, this.formDate.clearingFormId, "id", "name");
          this.formDate.cooperationClass = this.$fromatTable(this.supplierList, this.formDate.supplierId, "id", "gradeName");
          this.formDate.cooperationClassId = this.$fromatTable(this.supplierList, this.formDate.supplierId, "id", "gradeId");
          if (this.formDate.accessory.length != 0) {
            this.formDate.accessory = JSON.stringify(this.formDate.accessory);
          } else {
            this.formDate.accessory = "";
          }
          //站点数据重装-开始
          let stations = [];
          if (this.formDate.stationsList.length > 0) {
            let arr = [];
            this.formDate.stationsList.forEach(v => {
              this.sitelist.forEach(v2 => {
                if (v == v2.value) {
                  arr.push({
                    id: v,
                    name: v2.label,
                  });
                }
              });
            });
            stations = arr;
          }
          //站点数据重装-结束
          this.formDate.stations = JSON.stringify(stations);
          //业务点数据重组-开始
          let business = [];
          if (this.formDate.business.length > 0 || this.formDate.business != "[]") {
            let arr = [];
            this.formDate.business.forEach(v => {
              this.businessCheckbox.forEach(v2 => {
                if (v == v2.id) {
                  arr.push({
                    id: v,
                    name: v2.itemName,
                  });
                }
              });
            });
            business = arr;
          }
          this.formDate.accessory = JSON.stringify(this.files);
          // ============================== 新增核心逻辑：处理复用 ==============================
          // 由于复用时在 contractQueryDetailByIdFun 中已经将 this.formDate.id 置空，
          // 因此可以用 !this.formDate.id 判断当前是复用或单纯的新增状态。
          if (!this.formDate.id) {
            // 处理 dlist (设备价格) 以及它内部嵌套的 list (价格区间)
            if (this.formDate.dlist && this.formDate.dlist.length > 0) {
              this.formDate.dlist.forEach(item => {
                if (item.type == 2) item.type = 1; // 修改转新增
                if (item.list && item.list.length > 0) {
                  item.list.forEach(subItem => {
                    if (subItem.type == 2) subItem.type = 1; // 嵌套区间：修改转新增
                  });
                }
              });
            }
            // 处理 aplist (泵管价格)
            if (this.formDate.aplist && this.formDate.aplist.length > 0) {
              this.formDate.aplist.forEach(item => {
                if (item.type == 2) item.type = 1; // 修改转新增
              });
            }
            // 处理 plist (如果有使用的话一同兜底处理)
            if (this.formDate.plist && this.formDate.plist.length > 0) {
              this.formDate.plist.forEach(item => {
                if (item.type == 2) item.type = 1; // 修改转新增
              });
            }
          }
          const params = {
            ...this.formDate,
            business: JSON.stringify(business),
          };
          contractSaveOrUpdate(params).then(res => {
            if (res.code == 1001) {
              this.addDialog = false;
              this.$message.success("操作成功");
              this.init();
            }
          });
        } else {
          this.$message({
            message: "必填字段填写不完全！",
            type: "warning",
          });
          return false;
        }
      });
    },
    //获取合同详情 isCopy 判断是否是复用
    contractQueryDetailByIdFun(d,isCopy) {
      if (this.$refs.reffromDate) {
        this.$refs.reffromDate.resetFields();
      }
      this.addDialog = true;
      this.modifyType = true;
      this.cplistArr = [];
      contractQueryDetailById({ id: d }).then(async res => {
        this.formDate = { ...this.formDate, ...res.data.contract };
        this.changemainCompanyId(this.formDate.supplierId, true);
        this.formDate.startDayendDay = [];
        this.formDate.startDayendDay[0] = this.formDate.startDay;
        this.formDate.startDayendDay[1] = this.formDate.endDay;
        this.facilityTypeFun();
        this.formDate.dlist = this.copy(res.data.list);
        console.log(res.data.list);
        this.cplistArr = this.copy(res.data.list);
        this.formDate.aplist = this.copy(res.data.aplist);
        this.pumpListArr = this.copy(res.data.aplist);
        this.files = JSON.parse(this.formDate.accessory) || [];
        if (this.formDate.business) {
          let arr2 = [];
          JSON.parse(this.formDate.business).forEach(v => {
            arr2.push(v.id);
          });
          this.formDate.business = arr2;
        } else {
          this.formDate.business = [];
        }
        await this.companylistChangeFun(false, this.formDate.firstPartyId); //选择甲方公司后显示对应站点名称
        if (this.formDate.accessory != null) {
          this.formDate.accessory = JSON.parse(this.formDate.accessory);
        } else {
          this.formDate.accessory = [];
        }
        //判断公司-站点权限是否包含返回的详情id值，在就回显，不在就回显提示信息placeholder
        let type1 = this.companylist.findIndex(res => res.value == this.formDate.firstPartyId);
        if (type1 == -1) {
          this.formDate.firstPartyId = "";
          this.formDate.firstPartyIdPlaceholder = this.formDate.firstParty;
          let text = "";
          JSON.parse(this.formDate.stations).forEach(v => {
            text = text + v.name + " ";
          });
          this.formDate.stations = "";
          this.formDate.stationsPlaceholder = text;
        } else {
          if (this.formDate.stations) {
            let arr1 = [];
            JSON.parse(this.formDate.stations).forEach(v => {
              arr1.push(v.id);
            });
            this.formDate.stationsList = arr1;
          } else {
            this.formDate.stationsList = [];
          }
        }
        await this.stationsControlPointFun(true); //获取已选择站点名称的业务点
        if(isCopy){ // 复用id置空
          this.formDate.id = ""
        }
        this.$forceUpdate();
        console.log(JSON.parse(JSON.stringify(this.formDate)));
      });
    },
    //调价列表
    riseInPriceQueryOneByidFun(d) {
      this.contractId = d.id;
      this.riseInPriceQueryOneByidType = true;
      contractQueryDetailById({ id: d.id }).then(async res => {
        this.formDate = res.data.contract;
        this.cplistArr = this.copy(res.data.list);
        if (this.formDate.isPumpLine == 1) {
          this.pumpListArr = this.copy(res.data.aplist);
        }
      });
    },
    //价格设置-调价详情-列表
    QueryOneByidFun(d, moneyType) {
      this.modifyType = false;
      this.QueryOneByidType = true;
      this.QueryOneByidArr = [];
      this.contractRawMoneySaveForm.startTime = "";
      this.QueryOneByidObject.contractId = this.contractId;
      if (d) {
        this.moneyType = moneyType;
        this.QueryOneByidObject.rawId = d.id;
        console.log(JSON.parse(JSON.stringify(d)));
      }
      if (this.moneyType && this.formDate.facilityType == 1) {
        if (d) {
          this.carTwosArr = [];
          d.list.forEach((v, k) => {
            let json = {
              minDistance: k == 0 ? 0 : d.list[k - 1].distance, //距离
              maxDistance: v.distance,
              price: v.price,
              addDistance: v.addDistance, //价格
            };
            this.carTwosArr.push(json);
          });
        }
        this.QueryOneByidObject.contractFacility = this.QueryOneByidObject.rawId;
        PumpPriceLogQueryPage(this.QueryOneByidObject).then(res => {
          this.QueryOneByidArr = res.data;
        });
      } else {
        QueryOneByid(this.QueryOneByidObject).then(res => {
          this.QueryOneByidArr = res.data.data;
          this.QueryOneByidObject.total = res.data.totalRows;
        });
      }
    },
    basePriceListFun2(d) {
      console.log(d.contractFacility);
      this.basePriceListType2 = true;
      let obj = {
        contractId: d.contractId,
        contractFacility: d.contractFacility,
        startTime: d.startTime,
      };
      PumpPriceLogGetDetail(obj).then(res => {
        if (res.code == 1001) {
          this.carTwosArr2 = res.data;
        }
      });
    },
    //价格设置，提交
    contractRawMoneySaveFun() {
      if (!this.files2?.length) {
        return this.$message.warning("请上传附件文件");
      }
      this.$refs.contractRawMoneySaveForm.validate(valid => {
        if (valid) {
          this.contractRawMoneySaveForm.contractId = this.contractId;
          this.contractRawMoneySaveForm.rawId = this.QueryOneByidObject.rawId;
          this.contractRawMoneySaveForm.contractFacility = this.QueryOneByidObject.rawId;
          this.contractRawMoneySaveForm.filePaths = JSON.stringify(this.files2);
          if (this.moneyType && this.formDate.facilityType == 1) {
            /**判断区间范围是否正确--开始 */
            let type1 = false;
            let arr1 = this.carTwosArr;
            arr1.forEach((v, k) => {
              if (k > 0 && v.minDistance - arr1[k - 1].minDistance <= 0) {
                type1 = true;
              }
            });
            console.log(JSON.parse(JSON.stringify(arr1)), type1);
            /**判断区间范围是否正确--结束 */
            if (type1) {
              this.$message({
                message: "区间值范围不正确，请检查！",
                type: "warning",
              });
            } else {
              this.contractRawMoneySaveForm.list = this.carTwosArr;
              //合同类型-泵管的价格用
              PumpPriceLogSave(this.contractRawMoneySaveForm).then(res => {
                if (res.code == 1001) {
                  this.QueryOneByidFun();
                }
              });
            }
          } else {
            //泵管价格用
            contractRawMoneySave(this.contractRawMoneySaveForm).then(res => {
              if (res.code == 1001) {
                this.QueryOneByidFun();
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    //删除价格
    contractRawMoneyDeletesFun(d) {
      if (this.moneyType && this.formDate.facilityType == 1) {
        let obj = {
          contractId: this.contractId,
          contractFacility: d.contractFacility,
          startTime: d.startTime,
        };
        PumpPriceLogDeletes(obj).then(() => {
          this.QueryOneByidFun();
        });
      } else {
        contractRawMoneyDeletes({ id: d.id }).then(() => {
          this.QueryOneByidObject.page = 1;
          this.QueryOneByidFun();
        });
      }
    },
    //协作单位-开户信息
    cooperativeUnitFun(d) {
      this.cooperativeUnit_Dialog = true;
      queryListsByPid({ supplierId: d }).then(res => {
        this.cooperativeUnitArr = res.data;
      });
    },
    //协作单位组合
    queryListsByPidFun(d) {
      this.contractId = d.id;
      this.AllqueryListsByPid = true;
      console.log(d);
      queryListsByPid({ supplierId: d.supplierId }).then(res => {
        this.queryListsByPidArr = res.data;
        // let obj = {
        //   id: d.supplierId,
        //   name: d.supplierName,
        // };
        // this.queryListsByPidArr.splice(0, 0, obj);
      });
    },
    //开户信息详情
    contractAccountGetDetailFun(d) {
      this.contractAccountSaveForm = {};
      this.contractAccountGetDetailType = true;
      let obj = {
        contractId: d.id,
        pid: d.supplierId,
        type: 1,
      };
      contractAccountGetDetail(obj).then(res => {
        this.contractAccountSaveForm = res.data;
        this.$refs.contractAccountSaveForm.resetFields();
      });
    },
    //开户信息保存
    contractAccountSaveFun() {
      this.$refs.contractAccountSaveForm.validate(valid => {
        if (valid) {
          // this.formDate.contractPact = this.$fromatTable(
          //   this.contractPactIdArr,//未知
          //   this.formDate.contractPactId,
          //   "id",
          //   "name"
          // );
          contractAccountSave(this.contractAccountSaveForm).then(res => {
            if (res.code == 1001) {
              this.contractAccountGetDetailType = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    //重置表格-渲染
    reset() {
      this.modifyType = false;
      this.formDate = {
        startDayendDay: [],
        id: "",
        contractTypeId: "3",
        contractType: "设备租凭",
        facilityType: 1, //设备id
        firstParty: "", //甲方
        supplierName: "", //供应商
        supplierTypeId: "", //供应商类型id
        userId: "",
        userName: "",
        clearingSource: "", //结算原
        clearingForm: "", //结算方式
        accessory: [], //附件
        cooperationClass: "合作等级", //甲方公司里面出来的
        cooperationClassId: "合作等级id", //甲方公司里面出来的
        business: [], //业务点1，2，3
        isPumpLine: 1, //是否含泵管
        isPunpCar: 1, //是否泵车
        dlist: [], //设备表格价格+区间
        aplist: [],
        DATA_TYPE: 1,
        taxRate: "", //税率
      };
      this.cplistArr = [
        {
          id: "",
          deviceName: "", //设备名称
          deviceId: "", //设备id
          basePrice: 0, //单价
          assessmentPrice: 0, //考核价
          type: 1,
          list: [
            {
              id: "",
              distance: 1, //距离
              price: 0, //价格
              addDistance: 0, //每增加距离
              type: 1, //1新增，2修改，0删除
            },
            {
              id: "",
              distance: 2, //距离
              price: 0, //价格
              addDistance: 0, //每增加距离
              type: 1, //1新增，2修改，0删除
            },
            {
              id: "",
              distance: 9999999, //距离
              price: 0, //价格
              addDistance: 0, //每增加距离
              type: 1, //1新增，2修改，0删除
            },
          ],
        },
      ]; //供应产品列表显示部分
      this.businessCheckbox = [];
      this.pumpListArr = [
        {
          id: "",
          pumpType: "", //泵类型
          pumpTypeId: "", //泵类型id
          price: 0, //价格
          type: 1,
        },
      ];
      this.files = [];
    },
    /**合同编号是否重复 */
    queryContractNumberFun() {
      queryContractNumber({ contractNumber: this.formDate.contractNumber, id: this.formDate.id }).then(res => {
        if (res.code == 1001 && !res.data) {
          this.$message({
            message: "合同编号重复！",
            type: "warning",
          });
          this.formDate.contractNumber = "";
        }
      });
    },
    /**区间填入值不能小于等于前一个大于等于后一个 */
    inpuSizeCheck(val, k, arr) {
      let frontNumber = "",
        afterNumber = "";
      let l = k - 1;
      if (k < 0) {
        frontNumber = 0;
      } else {
        for (l; l >= 0; l--) {
          frontNumber = arr[l].distance;
          break;
        }
      }
      let i = k + 1;
      for (i; i < arr.length; i++) {
        afterNumber = arr[i].distance;
        break;
      }
      if (val - frontNumber <= 0) {
        console.log(val + ":" + frontNumber);
        this.$message({
          message: "区间值范围不正确，请检查！",
          type: "warning",
        });
      } else if (afterNumber - val <= 0) {
        console.log(afterNumber + ":" + val);
        this.$message({
          message: "区间值范围不正确，请检查！",
          type: "warning",
        });
      }
    },
    /**区间填入值不能小于等于前一个大于等于后一个 */
    inpuSizeCheck2(val, k, arr) {
      let frontNumber = "",
        afterNumber = "";
      let l = k - 1;
      for (l; l >= 0; l--) {
        frontNumber = arr[l].minDistance;
        break;
      }
      let i = k + 1;
      if (i == arr.length) {
        afterNumber = 9999999;
      } else {
        for (i; i < arr.length; i++) {
          afterNumber = arr[i].minDistance;
          break;
        }
      }
      if (val - frontNumber <= 0) {
        console.log(val + ":" + frontNumber);
        this.$message({
          message: "区间值范围不正确，请检查！",
          type: "warning",
        });
      } else if (afterNumber - val <= 0) {
        console.log(afterNumber + ":" + val);
        this.$message({
          message: "区间值范围不正确，请检查！",
          type: "warning",
        });
      }
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
  filters: {
    //站点list表格中拼接展示
    stationsFun(arr) {
      if (arr) {
        let ket = JSON.parse(arr).map(res => {
          return res.name;
        });
        return ket.join("、");
      } else {
        return "";
      }
    },
    //价格设置，是否显示价格输入框，对应价格区间显示
    moneyFun(facilityType, moneyType) {
      if (moneyType && facilityType == 1) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialoginfo {

  // .el-input,
  // .el-select {
  //   // width: 230px;
  // }
}

// .el-input,
// .el-select {
//   width: 240px;
// }

.table_link {
  margin-left: 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}

.form-title {
  font-size: 18px;
  margin: 10px 0;
}

.FZYguanKongYeWuDian {
  display: flex;

  >table {
    flex: none;
    width: 100px;
  }

  >div {
    flex: 1;
  }
}

.FZY1-3 {
  border-bottom: 1px solid #f2f2f2;

  .liBox1,
  .liBox2 {
    padding: 10px;
    width: 520px;
    display: flex;

    >div:nth-of-type(1) {
      width: 210px;
    }

    >div:nth-of-type(2) {
      flex: 1;
    }

    span {
      display: inline-block;
      margin-left: 20px;
    }

    .el-input-number ::v-deep {
      margin-left: 20px;
    }
  }

  .liBox3 {
    padding: 10px;
    width: 650px;
    display: flex;

    >div:nth-of-type(1) {
      display: flex;

      >div:nth-of-type(1) {
        width: 210px;

        span {
          margin-left: 10px;
        }

        .el-input-number ::v-deep {
          margin-left: 10px;
          width: 80px;
        }
      }

      span {
        display: inline-block;
        margin-left: 20px;
      }

      .el-input-number ::v-deep {
        margin-left: 20px;
      }
    }

    >div:nth-of-type(2) {
      width: 130px;
      flex: none;
      line-height: 28px;
      padding-left: 20px;
    }
  }
}
</style>
<style lang="scss">
.equipment {
  .FZYcheckbox {
    .el-checkbox {
      min-width: 155px;
      margin-right: 0px;
    }
  }

  // .FZYform {
  //   .el-form-item {
  //     min-width: 445px;

  //     .el-input,
  //     .el-select {
  //       width: 340px;
  //     }

  //     .hyyc {
  //       width: 310px;

  //       .el-input {
  //         width: 310px;
  //       }
  //     }
  //   }
  // }

  .FZYform2 {
    .el-form-item__error {
      white-space: nowrap;
    }
  }

  .FZYselectList {
    .el-select {
      width: 85px !important;
      margin-right: 10px;
    }
  }
}
</style>
